import "../../styles/ComponentsStyles/Universal/ShortModal.style.css";
import CloseBtnIcon from "../../assets/Icons/Universal/Cross.svg";
import PropTypes from "prop-types";

const ShortModal = ({
  isOpen = false,
  onClose,
  children,
}) => {
  return (
    <div
      className={`shortModal ${
        isOpen ? "shortModalOpen" : "shortModalClose"
      }`}
    >
      <div className="modalBackground" onClick={onClose}></div>
      <div className="shortModalContent">
        <div className="modalContentHeader">
          <button className="modalCloseBtn" onClick={onClose}>
            <img src={CloseBtnIcon} alt="" />
          </button>
        </div>
        <div className="modalContentContainer">{children}</div>
      </div>
    </div>
  );
};

export default ShortModal;

ShortModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};
